//@ts-ignore
import useResizeAware from "react-resize-aware";
import { CardLeftGradient } from "@Components/game/cards/styled-components";
import { BybButtonVR } from "@Components/game/common";
import {
  PlaylistCardDescription,
  PlaylistCardLargeContentWrapper,
  PlaylistCardLargeLeftContent,
  PlaylistCardLargeRoot,
  PlaylistCardTitle,
} from "@Components/game/playlists/common/cards/styled-components";
import { Events } from "@Context/common/general/context";
import useI18n from "@i18n";
import { Box, Typography } from "@mui/material";
import { PlaylistResponse } from "@Shared/schemas/playlists/playlistSchemas";

interface IPlaylistCardLarge {
  playlist: PlaylistResponse;
  disabled?: boolean;
  caption?: string;
}

const PlaylistCardLarge = ({ playlist, disabled, caption }: IPlaylistCardLarge) => {
  const [resizeListener] = useResizeAware();
  const { i18n } = useI18n();

  const handleClick = () => {
    Events.app.navigate.emit({ path: `/playlists/playlist/${playlist.id}` });
  };

  return (
    <>
      {resizeListener}
      <Box
        sx={{
          cornerShape: "squircle",
          borderRadius: "48px",
          height: 512,
          overflow: "hidden",
          position: "relative",
          ...(disabled && {
            opacity: 0.3,
            pointerEvents: "none",
          }),
        }}
      >
        <PlaylistCardLargeRoot imageUrl={playlist.image_url}>
          <PlaylistCardLargeContentWrapper>
            <PlaylistCardLargeLeftContent>
              <PlaylistCardTitle variant="text7xl700" color="common.white">
                {playlist.name}
              </PlaylistCardTitle>
              <PlaylistCardDescription variant="textLg500" color="common.white">
                {playlist.description}
              </PlaylistCardDescription>
              <Box>
                <BybButtonVR onClick={handleClick} disabled={disabled}>
                  {i18n("playlists.view.playlist")}
                </BybButtonVR>
              </Box>
            </PlaylistCardLargeLeftContent>
          </PlaylistCardLargeContentWrapper>
          <CardLeftGradient />
        </PlaylistCardLargeRoot>
      </Box>
    </>
  );
};

export default PlaylistCardLarge;
